import { render, staticRenderFns } from "./VaroantDialog.vue?vue&type=template&id=63c73367&scoped=true&"
import script from "./VaroantDialog.vue?vue&type=script&lang=js&"
export * from "./VaroantDialog.vue?vue&type=script&lang=js&"
import style0 from "./VaroantDialog.vue?vue&type=style&index=0&id=63c73367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c73367",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c73367')) {
      api.createRecord('63c73367', component.options)
    } else {
      api.reload('63c73367', component.options)
    }
    module.hot.accept("./VaroantDialog.vue?vue&type=template&id=63c73367&scoped=true&", function () {
      api.rerender('63c73367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/components/VaroantDialog.vue"
export default component.exports